import { DAY_NAMES } from "./constants";

export function recurrenceLabel(r) {
  const n = r.interval && r.interval > 1 ? r.interval : 1;
  switch (r.frequency) {
    case "once":
      return "One-time";
    case "daily":
      return n === 1 ? "Daily" : `Every ${n} days`;
    case "weekly": {
      const days =
        r.days_of_week && r.days_of_week.length
          ? [...r.days_of_week].sort((a, b) => a - b).map((d) => DAY_NAMES[d]).join(", ")
          : "Weekly";
      return n === 1 ? days : `Every ${n} wks · ${days}`;
    }
    case "monthly":
      return n === 1 ? "Monthly" : `Every ${n} months`;
    default:
      return "";
  }
}

// Is the task/chore due today (used to sort pending vs done).
export function isDue(r, lastISO) {
  const n = r.interval && r.interval > 0 ? r.interval : 1;
  if (r.frequency === "once") return !lastISO;
  const daysSince = lastISO
    ? Math.floor((Date.now() - new Date(lastISO).getTime()) / 86400000)
    : Infinity;
  switch (r.frequency) {
    case "daily":
      return daysSince >= n;
    case "weekly": {
      const wd = new Date().getDay();
      const days = r.days_of_week && r.days_of_week.length ? r.days_of_week : [wd];
      if (!days.includes(wd)) return false;
      return daysSince >= 7 * (n - 1) + 1;
    }
    case "monthly":
      return daysSince >= 30 * n;
    default:
      return daysSince >= 1;
  }
}

// Was a chore completed today (by last_completed_at)?
export function doneToday(lastISO) {
  if (!lastISO) return false;
  const d = new Date(lastISO);
  const now = new Date();
  return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
}
